import * as React from 'react';
import { cn } from 'lib/utils';

type ContainerProps = React.ComponentProps<'div'> & {
  hideArrows?: boolean;
  classNames?: {
    verticalLine?: string;
    item?: string;
    itemIndicator?: string;
    arrow?: string;
  }
}

export const Timeline = ({
                    className,
                    classNames,
  hideArrows,
                    children,
                    ...props
                  }: ContainerProps) => {

  const c = React.Children.toArray(children);

  return (
    <div {...props} className={cn('relative flex flex-col gap-8 items-start', className)}>
      {/* vertical line */}
      <div className={cn('absolute left-8 top-0 h-full border-l-2 border-gray-300', classNames?.verticalLine)} />
      {c.map((child, i) => (
        <div key={i} className={cn('relative flex items-center pl-16 w-full', classNames?.item)}>
          {/* item marker */}
          <div className={cn(
            'absolute -translate-y-1/2 mt-3 left-[27px] rounded-full h-3 w-3 bg-card border-4 border-gray-600',
            classNames?.itemIndicator,
          )} />
          {/* item triangle */}
          {!hideArrows && (
            <svg
              xmlns={'http://www.w3.org/2000/svg'}
              viewBox={'0 0 24 24'}
              className={cn(
                'absolute -translate-y-1/2 mt-6 left-[50px]',
                'w-6 h-6 fill-card',
                classNames?.arrow,
              )}>
              <polygon points="16,4 4,12 16,20" />
            </svg>
          )}
          {child}
        </div>
      ))}
    </div>
  );
};


